export default "__VITE_ASSET__NAZZ8dFn__"